module.exports = __webpack_public_path__ + "media/hallBgm.f8e01640.mp3";